"use strict";

import dispatcher from "./../dispatcher";
import {Collection} from "vwa/flux";
import vehicleStore from "./vehicles";
import filterGroups from "vwa/utils/filterGroups";

const pinnedVehicleStore = new Collection();
export default pinnedVehicleStore;

window.pinnedVehicleStore = pinnedVehicleStore;

vehicleStore.on('set', vehicles => {
	if (!vehicles)
		pinnedVehicleStore.set(null);
});

vehicleStore.on('insert', vehicles => {
	
	// amennyiben az összes jármű fel van pinelve,
	// úgy feltételezzük, hogy ezt is fel akarjuk pinelni
	
	const numOfVehicles = filterGroups(vehicleStore.getAll()).length;
	const numOfPinnedVehicles = pinnedVehicleStore.getAll().length;
	
	if (numOfVehicles == numOfPinnedVehicles + vehicles.length) {
		pinnedVehicleStore.insert(vehicles.map(v => v._id));
	}
});

vehicleStore.on('remove', vehicles =>
	pinnedVehicleStore.remove(vehicles.map(v => v._id))
);

dispatcher.on('pinVehicles', (vehicleIds, value) => {
	
	if (!vehicleIds)
		return;
	
	if (value == true)
		pinnedVehicleStore.insert(vehicleIds);
	else
		pinnedVehicleStore.remove(vehicleIds);
});


// WEBPACK FOOTER //
// ./src/store/pinnedVehicles.js